import React from 'react';
import PdqOrderMerchants from './pdq-order-merchant.component';

const PdqOrderMerchantsContainer = (props) => {
    const merchantId = props.match?.params?.merchantId;
    return <PdqOrderMerchants {...props} merchantId={merchantId} />;
};

export default PdqOrderMerchantsContainer;
